import { Content } from '@tiptap/core/dist';

/**
 * Turn a string into a TipTap content object and convert newlines into paragraphs.
 */
export const escapeContent = (text: string): Content => {
  const paragraphs = text.split('\n').map(paragraph => {
    return paragraph ? {
      type: 'paragraph',
      content: [{
        type: 'text',
        text: paragraph,
      }],
    } : {
      type: 'paragraph',
    };
  });

  return {
    type: 'doc',
    content: paragraphs,
  };
};

export const removeParagraphsFromListItems = (html: string): string => {
  return html.replace(/<li>(.*?)<\/li>/g, (match, content) => {
    const cleanedContent = content.replace(/<div>(.*?)<\/div>/g, '$1');

    return `<li>${cleanedContent}</li>`;
  });
};
